import type { PaqueteDePais } from '@actualgold/localizacion';
import { useTranslation } from 'react-i18next';
import { usePaqueteDeLaEmpresa } from './ProveedorDeSesion';

/**
 * Lo fiscal del país de la empresa, listo para dibujar un formulario (E35).
 *
 * Las listas salen del paquete de país —el mismo que valida en el servidor— y no se escriben a
 * mano en cada pantalla: así una ficha de cliente chilena ofrece RUT y no CUIT, y no hay una
 * pantalla que quede atrás cuando entra otro país.
 */
export interface FiscalDeLaEmpresa {
  readonly paquete: PaqueteDePais | null;
  readonly tiposDeTercero: readonly string[];
  readonly condicionesDeTercero: readonly string[];
  nombreDeTipo(tipo: string): string;
  nombreDeCondicion(condicion: string): string;
}

export function useFiscalDeLaEmpresa(): FiscalDeLaEmpresa {
  const { t } = useTranslation();
  const paquete = usePaqueteDeLaEmpresa();
  return {
    paquete,
    tiposDeTercero: paquete?.tiposDeIdentificacionDeTercero ?? [],
    condicionesDeTercero: paquete?.condicionesDelReceptor ?? [],
    nombreDeTipo: (tipo) => t(`identificaciones.${tipo}`, tipo),
    nombreDeCondicion: (condicion) =>
      paquete === null
        ? condicion
        : t(`condicionesFiscales.${paquete.codigo}.${condicion}`, condicion),
  };
}
